import { SORT, LINKED_INTERVENTION, CAMPAIGN_FILES_STATUS } from 'constants/FilterConstants';
import * as types from 'modules/campaignFiles/actionTypes';
import { DEFAULT_BULK_SORT } from 'modules/campaignFiles/constants';
import { emptyState as defaultState } from 'modules/campaignFiles/reducers/ui/filters';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'linkedIntervention' | 'campaignFileStatus' | 'sort' } OmittedFilter */
/** @typedef {Omit<import("./filters").CampaignFileUIDetailsFiltersReducer, OmittedFilter>} CampaignFileUIBulkFiltersReducer */

const EXCLUDED_FILTERS = [LINKED_INTERVENTION, CAMPAIGN_FILES_STATUS, SORT];

/**
 * @param {Partial<CampaignFileUIDetailsFiltersReducer>} state
 * @param {Partial<CampaignFileUIBulkFiltersReducer>} initialValue
 * @returns {CampaignFileUIBulkFiltersReducer}
 */
export const reduceFilters = (state, initialValue) =>
  Object.entries(state).reduce((acc, [field, value]) => {
    if (!EXCLUDED_FILTERS.includes(field)) {
      return { ...acc, [field]: value };
    }
    return acc;
  }, initialValue);

/** @type {CampaignFileUIBulkFiltersReducer} */
export const emptyState = reduceFilters(defaultState, { [SORT]: DEFAULT_BULK_SORT });
/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<CampaignFileUIBulkFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState);

// Remove excluded filters from the payload
const importFilters = (state, { payload }) => reduceFilters(payload, state);

export default createReducer(filterAdapter.getInitialState(), {
  [types.IMPORT_CAMPAIGN_FILES_BULK_FILTER]: importFilters,
  [types.CLOSE_CREATION_MODAL]: filterAdapter.resetFilters,
  [types.SET_CAMPAIGN_FILES_BULK_FILTER]: filterAdapter.setFilter,
  [types.CLEAR_CAMPAIGN_FILES_BULK_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CAMPAIGN_FILES_BULK_FILTER]: filterAdapter.removeFilter,
});
